import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import styled from 'foundations-theming/utils';
import { useAbstractTextElementContext } from '../AbstractTextElement/AbstractTextElementProvider';
import { deepMerge } from '../../utils/deepMerge';
import { jsx as _jsx } from "react/jsx-runtime";
// The `as` prop will determine the tag name of the element.
const StyledTag = styled.span.withConfig({
  displayName: "AbstractElement__StyledTag"
})(({
  $cssStyles,
  $styleOverrides
}) => {
  return deepMerge($styleOverrides, $cssStyles);
});
export const AbstractElement = _ref => {
  var _abstractTextElementC;
  let {
      tagName = 'span',
      id,
      role,
      disabled,
      title,
      tabIndex,
      'aria-hidden': ariaHidden,
      'aria-describedby': ariaDescribedby,
      'aria-description': ariaDescription,
      'aria-label': ariaLabel,
      children,
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, ["tagName", "id", "role", "disabled", "title", "tabIndex", "aria-hidden", "aria-describedby", "aria-description", "aria-label", "children", DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE].map(_toPropertyKey));
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const abstractTextElementContext = useAbstractTextElementContext();
  return /*#__PURE__*/_jsx(StyledTag, Object.assign({}, domProps, callbackProps, {
    as: tagName,
    id: id,
    role: role,
    disabled: disabled,
    title: title,
    tabIndex: tabIndex,
    "aria-hidden": ariaHidden,
    "aria-describedby": ariaDescribedby,
    "aria-description": ariaDescription,
    "aria-label": ariaLabel,
    $cssStyles: cssStyles,
    $styleOverrides: (_abstractTextElementC = abstractTextElementContext === null || abstractTextElementContext === void 0 ? void 0 : abstractTextElementContext.abstractElementStylesOverrides) !== null && _abstractTextElementC !== void 0 ? _abstractTextElementC : {},
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute || 'AbstractElement',
    children: children
  }));
};
AbstractElement.displayName = 'AbstractElement';